<template>
  <div>
    <div
      class="absolute font-light leading-7 bg-white pt-2 box-border rounded-lg z-50"
      style="
        top: 52px;
        right: 40px;
        width: 600px;
        height: 700px;
        box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3);
      "
      v-body-scroll-lock="true"
    >
      <div>
        <div
          class="flex justify-between items-end mx-11 py-6"
          :class="{
            'border-b border-gray-12': state.notifications.length !== 0,
          }"
        >
          <div
            class="block w-full text-left font-semibold leading-4 w-32 text-xl text-gray-92"
            style="width: 112px"
          >
            お知らせ
          </div>
          <div
            v-if="state.notifications.length > 0"
            class="leading-4 cursor-pointer font-semibold text-gray-62 text-xs"
            @click="readAllNotification"
          >
            すべて既読にする
          </div>
        </div>
        <div
          :class="{ 'overflow-y-scroll': state.notifications.length !== 0 }"
          style="height: 544px"
        >
          <div
            v-if="state.notifications.length === 0"
            class="flex justify-center"
          >
            <div
              class="flex justify-center items-center border border-gray-12 round-sm"
              style="height: 130px; width: 520px"
            >
              現在新しいお知らせはありません。
            </div>
          </div>
          <div v-else>
            <div
              v-for="notification in state.notifications"
              :key="notification.id"
              class="hover:bg-slate-100"
            >
              <router-link
                :to="{
                  name: 'NotificationDetail',
                  params: { notificationId: notification.id },
                }"
                @click="closeDialog"
              >
                <div
                  class="mx-11 py-3 text-left text-gray-92 border-b border-gray-12"
                >
                  <div class="flex items-start">
                    <div style="width: 10px; height: 10px">
                      <span
                        v-if="notification.is_unread"
                        class="inline-block bg-coral-main rounded-full mt-2"
                        style="width: 10px; height: 10px"
                      ></span>
                    </div>
                    <div class="flex-1 flex justify-between items-center">
                      <div class="flex flex-col mx-4">
                        <div class="font-semibold leading-5">
                          {{ notification.subject }}
                        </div>
                        <span class="text-gray-62 leading-5 text-xs">{{
                          notification.display_start_at
                        }}</span>
                      </div>
                      <img class="w-4" src="@/assets/icons/ChevronRight.svg" />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div
          v-if="state.notifications.length > 0"
          class="flex items-center justify-center my-5"
        >
          <router-link :to="{ name: 'NotificationIndex' }" @click="closeDialog">
            <div
              class="font-semibold text-sm text-gray-92 cursor-pointer px-11 py-3 rounded hover:text-gray-92 hover:bg-slate-100 border"
            >
              すべてのお知らせ
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="fixed inset-0 z-40" @click="closeDialog"></div>
  </div>
</template>

<script>
import { reactive, inject, onMounted, onBeforeUnmount } from 'vue';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import axios from '@/utils/axios.js';
import utils from '@/utils/utils.js';

export default {
  emits: ['close-notification'],
  setup(props, context) {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      notifications: [],
    });

    onMounted(async () => {
      getNotificationData();
    });

    onBeforeUnmount(() => {
      clearAllBodyScrollLocks();
    });

    const getNotificationData = async () => {
      await axios
        .get('/user-notifications/latest')
        .then((response) => {
          state.notifications = response.data.data;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    const readAllNotification = async () => {
      await axios
        .post('/user-notification-first-read/register')
        .then((response) => {
          if (response.data.result === 'success') {
            getNotificationData();
            context.emit('read-all-notification');
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    const closeDialog = () => {
      context.emit('close-notification');
    };

    return {
      state,
      readAllNotification,
      closeDialog,
      utils,
    };
  },
};
</script>

<style></style>
